import { operatorList, operatorStatus, editOperator, addOperator, adminDel } from '@/api/accountInfo'
const state = {
  // 操作员
  tableData: [],
  queryControl: {
    keyword: '',
    account: ''
  },
  pageControl: {
    pageNumber: 1,
    pageSize: 10,
    total: 0
  }
}
const getters = {
  tableData: state => state.tableData,
  pageControl: state => state.pageControl,
  queryControl: state => state.queryControl
}
const mutations = {
  save: (state, payload) => {
    Object.keys(payload).forEach(e => {
      if (Object.prototype.toString.call(state[e]) === '[object Object]') {
        state[e] = {
          ...state[e],
          ...payload[e]
        }
      } else {
        state[e] = payload[e]
      }
    })
  }
}
const actions = {
  // 操作员列表
  operatorListFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await operatorList(params)
      if (code === 200) {
        commit('save', {
          tableData: data.data,
          pageControl: {
            ...state.pageControl,
            total: data.total
          }
        })
        resolve()
      }
    })
  },
  // 启/禁用管理员状态
  operatorStatusFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await operatorStatus(params)
      res.code === 200 && resolve(res)
    })
  },
  // 编辑管理员
  editOperatorFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await editOperator(params)
      res.code === 200 && resolve(res)
    })
  },
  // 添加管理员
  addOperatorFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await addOperator(params)
      res.code === 200 && resolve(res)
    })
  },
  // 删除管理员
  adminDel(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await adminDel(params)
      res.code === 200 && resolve(res)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

